import { styleSheet } from '../../style-sheet';

import { Image, View } from '@react-pdf/renderer';

export type ProposalDocumentBackPanelProps = {
	image: string;
}

export const ProposalDocumentPageBackPanel = ({ image }: ProposalDocumentBackPanelProps) => {
	return (
		<View>
			<View style={styleSheet.containerCenter}>
				<Image src={image} style={styleSheet.fullImage}/>
			</View>
		</View>
	);
};
